export default __webpack_public_path__ + "static/media/311.054c8c88.svg";